// @ts-nocheck

import { createSelector } from 'reselect';

import { MPGlobalStatuses } from '../../types/global';
import { selectMPGlobalStatus } from '../global';

const MPEnrollmentButtonSelectors = {};

MPEnrollmentButtonSelectors.selectIsDisabled = createSelector(
  [selectMPGlobalStatus],
  (globalStatus) => globalStatus === MPGlobalStatuses.ENDING,
);

export default MPEnrollmentButtonSelectors;
